<script lang="ts" setup>
import Image from '@/shared/components/UI/Image.vue';

defineProps<{
  imageUrl: string;
  totalImageCount: number;
  fallbackImageUrl?: string;
}>();

const emit = defineEmits(['click']);
</script>
<template>
  <div class="relative cursor-pointer overflow-hidden bg-gray-100">
    <div
      ref="container"
      class="size-full bg-gray-100 transition-all duration-150"
    >
      <Image
        :src="imageUrl"
        img-classes="aspect-square size-full object-cover transition-transform duration-300 lg:hover:scale-105"
        :fallback-image-url="fallbackImageUrl"
        @click="emit('click')"
      />
      <div
        v-if="totalImageCount > 1"
        class="absolute bottom-1 right-1 rounded bg-black/80 px-1.5 py-1 text-sm font-bold leading-none text-white"
      >
        +{{ totalImageCount - 1 }}
      </div>
    </div>
  </div>
</template>
